import React, { useEffect, useState } from 'react'
import { MdArrowBack } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import Loading from '../Loading'

export default function NewPassword(props) {
    const [errorMessage, setErrorMessage] = useState('')
    const [progress, setProgress] = useState(false)
    const { t, locale } = useTranslation()

    const handleSubmit = async (e) => {
        e.preventDefault()
        setProgress(true)
        const resp = await props.onSubmit(props.email)
        if (resp.status === 200) {
            props.setAuthSection('token')
        } else {
            const error = resp?.data?.message || resp.data
            setErrorMessage(error)
        }
        setProgress(false)
    }

    return (
        <div className="new-password-container">
            <div className="modal-title">
                <p className="text-left font-bold  text-3xl text-textLight">{t('newPassword')}</p>
            </div>
            <div className="text-left text-textLight text-sm mt-2">
                <p>{t('enterYourSchoolEmailAndWeWillSendYouALinkToGetBackIntoYourAccount')}</p>
            </div>
            <div className="sign-up-section">
                <div className="">
                    <form onSubmit={handleSubmit}>
                        <div className="my-5">
                            <span className="text-textLight text-lg font-semibold text-left flex justify-start">{t('email')}</span>
                            <input
                                className="w-full text-textLight border border-b-deselectPurple py-3 border-x-0 border-t-0"
                                placeholder={t('email')}
                                style={{ backgroundColor: 'transparent' }}
                                value={props.email}
                                // type="email"
                                name="email"
                                onChange={(e) => props.setEmail(e.target.value)}
                            />
                        </div>
                        <div className="error-message">{errorMessage}</div>
                        <div className="login-form-element-holder px-6 py-3">
                            <button
                                className={`bg-white text-textDark py-3 text-lg font-semibold rounded-full w-full h-[50px] ${
                                    !progress ? 'hover:bg-aquaPulse hover:text-textLight' : ''
                                } duration-[250ms] ease-in-out transition-all flex items-center justify-center`}
                                disabled={progress}
                            >
                                {progress ? <Loading primaryColor="var(--deep-ocean)" /> : t('sendRequest')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
